/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handy everyday tools — measure, generate, decide.`)
};

const es_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas prácticas para el día a día: medir, generar, decidir.`)
};

const de_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praktische Alltagstools — messen, generieren, entscheiden.`)
};

const nl_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handige tools voor elke dag — meten, genereren, beslissen.`)
};

const fr_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des outils pratiques pour le quotidien — mesurer, générer, décider.`)
};

const it_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti utili per la vita quotidiana — misura, genera, decidi.`)
};

const pt_br2_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas práticas para o dia a dia — medir, gerar, decidir.`)
};

const pt_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas práticas para o dia a dia — medir, gerar, decidir.`)
};

const ja_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計測・生成・決定に役立つ日常ツール。`)
};

const zh_cat_everyday_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实用的日常工具——测量、生成、决策。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_everyday_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_everyday_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_everyday_desc", locale)
	if (locale === "en") return en_cat_everyday_desc(inputs)
	if (locale === "es") return es_cat_everyday_desc(inputs)
	if (locale === "de") return de_cat_everyday_desc(inputs)
	if (locale === "nl") return nl_cat_everyday_desc(inputs)
	if (locale === "fr") return fr_cat_everyday_desc(inputs)
	if (locale === "it") return it_cat_everyday_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_everyday_desc(inputs)
	if (locale === "pt") return pt_cat_everyday_desc(inputs)
	if (locale === "ja") return ja_cat_everyday_desc(inputs)
	return zh_cat_everyday_desc(inputs)
};